import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClarificationRecord } from "../SeekClarificationTray";

interface AccessHoldPayload {
  step2_details: Record<string, any>;
  isLocationTypeChanged?: boolean;
}

interface ClarificationState {
  clarificationData: ClarificationRecord | null;
  /** ✅ Stashed step2_details from AccessQuestionMain (used when clarification === false) */
  accessHoldPayload: AccessHoldPayload | null;
}

const initialState: ClarificationState = {
  clarificationData: null,
  accessHoldPayload: null,
};

const clarificationSlice = createSlice({
  name: "clarification",
  initialState,
  reducers: {
    setClarificationData: (
      state,
      action: PayloadAction<ClarificationRecord | null>,
    ) => {
      state.clarificationData = action.payload;
    },
    clearClarificationData: (state) => {
      state.clarificationData = null;
      state.accessHoldPayload = null; // ✅ also clear stash
    },

    /** ✅ NEW: stash step2_details from AccessQuestionMain */
    setAccessHoldPayload: (
      state,
      action: PayloadAction<AccessHoldPayload | null>,
    ) => {
      state.accessHoldPayload = action.payload;
    },

    /** ✅ NEW: clear only the stash (keeps clarificationData intact) */
    clearAccessHoldPayload: (state) => {
      state.accessHoldPayload = null;
    },
  },
});

export const {
  setClarificationData,
  clearClarificationData,
  setAccessHoldPayload,
  clearAccessHoldPayload,
} = clarificationSlice.actions;

export default clarificationSlice.reducer;